import axios from 'axios';
import { MarketId } from 'types/market-id.enum';
import { OwnerType } from 'types/shared/owner-type.enum';
import { UpdateFeedStrategyInput } from 'views/profiles-strategies/features/feed-strategies/types/update-feed-strategy-input.type';

//TODO a lot of feed strategy endpoints are shared in planning and prognosis. make shared CRUD folder and import them into subfeature's CRUD folder?

// POST
// /ewosapi/v2/planandprognosis/feedstrategy/market/{marketId}
// Create a Feed Strategy for market/country
export const postFeedStrategy = async (owner: OwnerType, id: MarketId | string, request: UpdateFeedStrategyInput): Promise<number> => {
  const res = await axios.post(`/ewosapi/v2/planandprognosis/feedstrategy/${owner}/${id}`, request);
  return res.data;
};
